const DARK_MODE_KEY = "onec_dark_mode";
const LEGACY_THEME_KEY = "theme";

/** Dark mode applies only inside dashboard layouts, not public or auth pages. */
export function isAuthenticatedPath(pathname: string): boolean {
  return pathname.startsWith("/admin") || pathname.startsWith("/employer");
}

export function readDarkModePreference(): boolean {
  try {
    const stored = localStorage.getItem(DARK_MODE_KEY);
    if (stored !== null) return stored === "true";

    const legacy = localStorage.getItem(LEGACY_THEME_KEY);
    if (legacy === "dark") return true;
    if (legacy === "light") return false;

    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  } catch {
    return false;
  }
}

export function applyDarkModeToDocument(
  isDarkPreferred: boolean,
  pathname: string = window.location.pathname
): void {
  const root = document.documentElement;
  root.classList.remove("dark-mode");

  if (isDarkPreferred && isAuthenticatedPath(pathname)) {
    root.setAttribute("data-theme", "dark");
  } else {
    root.removeAttribute("data-theme");
  }
}

export function persistDarkModePreference(isDark: boolean): void {
  try {
    localStorage.setItem(DARK_MODE_KEY, String(isDark));
    localStorage.removeItem(LEGACY_THEME_KEY);
  } catch {
    // ignore storage errors
  }
}
